
















































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormServer1Streamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraServerStreamax'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.enable.value =
      this.data['?column?'][0].EN == '0' ? false : true;
    this.formFields.protocolType.value = this.data['?column?'][0].CP;
    this.formFields.registerServerIp.value = this.data['?column?'][0].CS;
    this.formFields.mediaServerIp.value = this.data['?column?'][0].MS;
    this.formFields.tcp.value = this.data['?column?'][0].CPORT;
    this.formFields.udp.value = this.data['?column?'][0].MPORT;
    this.formFields.tcpMedia.value = this.data['?column?'][0].CUPORT;
    this.formFields.udpMedia.value = this.data['?column?'][0].MUPORT;
  }
  mounted() {
    this.getTime();
  }
  formFields: {
    enable: any;
    protocolType: any;
    enableNetwork: any;
    registerServerIp: any;
    tcp: any;
    udp: any;
    mediaServerIp: any;
    tcpMedia: any;
    udpMedia: any;
  } = {
    protocolType: {
      label: 'Protocol Type',
      value: 0,
      items: [
        { label: 'N9M', id: 0 },
        { label: 'Zhida', id: 1 },
        { label: '808 protocal', id: 2 },
        { label: 'Other', id: 3 },
      ],
    },
    enableNetwork: {
      label: 'Enable Network',
      value: 0,
      items: [
        { label: 'Module1', id: 0 },
        { label: '', id: 1 },
        { label: '', id: 2 },
      ],
    },
    registerServerIp: {
      label: 'Register Server IP',
      value: '',
    },
    tcp: {
      label: 'TCP',
      value: '5556',
    },
    udp: {
      label: 'UDP',
      value: '6222',
    },
    mediaServerIp: {
      label: 'Media Server IP',
      value: 'wcms.gpschile.com',
    },
    enable: {
      label: 'ON',
      check: true,
    },
    tcpMedia: {
      label: 'TCP',
      value: '5556',
    },
    udpMedia: {
      label: 'UDP',
      value: '6222',
    },
  };
  selectedProtocolType() {
    return this.formFields.protocolType.items.find(
      (item: { id: any }) => item.id === this.formFields.protocolType.value
    );
  }
  selectedEnableNetwork() {
    return this.formFields.enableNetwork.items.find(
      (item: { id: any }) => item.id === this.formFields.enableNetwork.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
